<template>

    <el-select :domainid="domainid"
               :value="value"
               :multiple="multiple"
               :collapse-tags="multiple"
               :filterable="filterable"
               :clearable="clearable"
               :disabled="disabled"
               :size="size"
               @change="change($event)">
        <el-option v-for="item in domainList"
                   :label="item.description"
                   :value="item.value"
                   :key="item.value"></el-option>
    </el-select>

</template>


<script>

    import selectUtil from '@/util/common/select'
    // import DomainalnApi from '@/api/domainaln'
    import { dictionaryContainer, DICTIONARY_FACTORY_DOMAIN } from '@/util/common/dictionary'

    export default {

        name: 'domainSelect',

        props: ['value', 'multiple', 'allowAll', 'filterable', 'clearable', 'disabled', 'size', 'domainid'],

        data() {
            return {
                oldKeys: [],
                domainList: [],
            }
        },

        mounted() {
            dictionaryContainer.getDictionary(DICTIONARY_FACTORY_DOMAIN, this.domainid).then((dictionary) => {
                this.domainList = dictionary.items;
                if (this.multiple && this.allowAll) {
                    this.domainList = selectUtil.allowAll(this.domainList, 'value', 'description');
                }
                this.$emit(`fetch_${this.domainid}_list`, this.domainList);
            });
            /*DomainalnApi.list({domainid: this.domainid}).then(responseBody => {
                this.domainList = responseBody;
                if (this.multiple && this.allowAll) {
                    this.domainList = selectUtil.allowAll(this.domainList, 'value', 'description');
                }
                this.$emit(`fetch_${this.domainid}_list`, this.domainList);
            })*/
        },

        methods: {

            change: function (newDomainalnKeys) {
                if (this.multiple) {
                    this.$emit('input', selectUtil.getSelectedItems(this.oldKeys, this.domainList, newDomainalnKeys, 'value'));
                } else {
                    this.$emit('input', newDomainalnKeys);
                }
            },

        },


    }

</script>